import { defineComponent } from "vue";
import PtButton from "@com/pt-components/pt-button/index.vue";
export default defineComponent({
    components: {
        PtButton: PtButton
    },
    props: {
        badge: {
            type: Boolean,
            default: false
        },
        dark: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props) {
        return {};
    }
});
